import { createActionGroup, props } from "@ngrx/store";
import { SalesSupportPerson } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

export const DataSalesSupportPersonsActions = createActionGroup({
    source: "Data / Sales Support Persons",
    events: {
        "Load": props<{ companyId: string }>(),
        "Load Success": props<{ salesSupportPersons: SalesSupportPerson[] }>(),
        "Load Failure": props<{ error: AppError; toastKey: string }>(),
    },
});
